









































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import ModalConfig from '@/components/modal-config/index.vue';
import { sendProcess, sendAgain } from '@/api/fixed-car-management';
@Component({
  name: 'DistributionTrack',
  components: { ModalConfig }
})
export default class DistributionTrack extends Vue {
  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  // 数据
  @Prop()
  data!: any;
  list: any[] = [];
  submitBtn: boolean = false;
  loading: boolean = false;
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }
  //初始化 获取下发轨迹
  async init() {
    const { businessKey, businessType, sendStatus, parkId, createTime } = this.data;
    const json = { businessKey, businessType, sendStatus, parkId, createTime };
    this.loading = true;
    try {
      const { data } = await sendProcess(json);
      this.list = data.data || [];
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }
  //重新下发
  async redistribute() {
    const { businessKey, businessType, parkId } = this.data;
    const json = { businessKey, businessType, parkId };
    if (this.submitBtn) return;
    this.submitBtn = true;
    try {
      const { data } = await sendAgain(json);
      this.$message.success(data || '操作成功');
      this.$emit('redistribute');
    } catch (e) {
      this.$message.error((e && e.msg) || '系统异常，请稍后再试');
    } finally {
      this.submitBtn = false;
    }
  }
  //取消
  closeIt() {
    this.$emit('closeIt');
  }
  mounted() {
    // this.init();
  }
}
